import {
  ref, watch,
} from '@vue/composition-api'

export default {
  name: 'PopupDrawer',
  props: {
    noPaddings: Boolean,
    close: String,
    value: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '38rem',
    },
    maxWidth: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
    eager: Boolean,
    fullScreen: Boolean,
  },
  setup(props, context) {
    const show = ref(props.value)

    const { emit } = context
    watch(() => props, () => {
      show.value = props.value
    }, { deep: true, immediate: true })

    const on = {
      click: () => {
        show.value = true
        emit('input', true)
      },
    }

    const hide = () => {
      show.value = false
      emit('input', false)
    }


    return {
      hide,
      show,
      on,
    }
  },
}
